import { render } from "./OrganizationsView.vue?vue&type=template&id=e933c502&ts=true"
import script from "./OrganizationsView.vue?vue&type=script&lang=ts"
export * from "./OrganizationsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__